import React from 'react';
import Button from '../../components/@base/Button';

/**
 * Botão para remoção de componente
 * @param {*} props
 * @returns
 */
export function ComponentConfigurationRemoveButton(props) {
  const clickHandler = () => {
    props.setState({
      removeComponent: true,
      boxConfigurationOpened: false,
    });
  };

  return (
    <Button
      circle
      small
      title="Apagar componente"
      onClick={clickHandler}
      disabled={props.component.notAllowedDelete}
    >
      <i className="fa fa-trash" aria-hidden="true" />
    </Button>
  );
}

export default ComponentConfigurationRemoveButton;
